import { useNavigate } from 'react-router-dom';
import permissions, { Permission } from '../../../../common/permissions';
import { ROUTES } from '../../config';

export function usePermissions() {
  const navigate = useNavigate();

  const checkPermissions = async (permissionsToCheck: Permission[], redirect = true) => {
    if (!(await permissions.hasSomePermissions(permissionsToCheck))) {
      if (redirect) navigate(ROUTES.forbidden);
      return false;
    }
    return true;
  };

  return { checkPermissions };
}
